import updateIsActiveArray from "utils/updateIsActiveArray";

function updateArray(sidebarIsActiveArray: boolean[], index: number) {
  return updateIsActiveArray(sidebarIsActiveArray, index);
}

export default updateArray;
